<template>
  <div v-if="service">
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>{{service.name}}</v-toolbar-title>
    </v-toolbar>
    <v-container fluid class="pa-0">
      <v-row>
        <v-col cols="12">
          <v-card elevation="0">
            <v-card-text v-html="service.intro"></v-card-text>
            <v-card-text>
              <v-btn small color="primary" @click="createOrder()" class="themed">SUIVANT</v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      serviceId: null,
      service: null
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.$route.params.id) {
        this.serviceId = parseInt(this.$route.params.id);
        this.getService();
      } else {
        this.$router.push("/services");
      }
    },
    getService() {
      this.$store.dispatch("services/get", this.serviceId).then(() => {
        this.service = this.$store.getters["services/service"];
      });
    },
    createOrder() {
      this.$store
        .dispatch("order/create", { serviceId: this.serviceId })
        .then(data => {
          this.$router.push("/orders/view/" + data.id);
        });
    }
  }
};
</script>

<style>
</style>